import angular from 'angular';
import { VerifyPhoneConfig } from './phone.config';
import { VerifyPhoneComponent } from './phone.component';
import { VerifyPhoneComponent as UdsVerifyPhoneComponent } from '../new-design/phone/phone.component';
import { VerifyPhoneCodeModule } from './code';
import { InvalidModalComponent } from './invalid-modal';
import { CardModule } from '../../core';
import { PhoneVerificationDirective } from './phone-verification.directive';
import { LoadingDotsModule } from '../../common/directives';
import { TermsOfUseModule } from '../terms-of-use';

export const VerifyPhoneModule = angular
  .module('app.verify.phone', [
    CardModule.name,
    LoadingDotsModule.name,
    TermsOfUseModule.name,
    VerifyPhoneCodeModule.name,
  ])
  .config(VerifyPhoneConfig)
  .component('updVerifyPhone', VerifyPhoneComponent)
  .component('udsVerifyPhone', UdsVerifyPhoneComponent)
  .component('updVerifyPhoneInvalidModal', InvalidModalComponent)
  .directive('updPhoneVerification', PhoneVerificationDirective);
